import React, {Fragment} from "react";
import {Col, Divider, Tabs, Typography} from "antd";
import {
    AlertOutlined,
    CommentOutlined,
    EnvironmentOutlined,
    FileOutlined,
    LinkOutlined,
    NodeIndexOutlined,
    SkinOutlined,
    TagsOutlined
} from "@ant-design/icons";
import {FicheEnfants} from "./fiche-enfants";
import {FicheFamilleLink} from "./fiche-famille-link";
import {isMobile} from "react-device-detect";
import {FicheAdresses} from "./fiche-adresses";
import {FicheCom} from "./fiche-com";
import {FicheLinks} from "./fiche-links";
import {FicheDocs} from "./fiche-docs";
import {FicheCategories} from "./fiche-categories";
import {FicheRappel} from "./fiche-rappel";

const {Text, Title} = Typography

export class FicheTabs extends React.Component {

    state = {
        key: "0"
    }

    onChange(key) {
        this.setState({key: key})
    }

    render() {
        const {selected, fiche} = this.props

        if (!selected) {
            return null
        }

        let tabs = []

        if (selected.deceased) {
            tabs.push({
                key: "dr",
                label: (<Fragment><AlertOutlined/> {selected.rappels.length} Rappel(s) Contact</Fragment>),
                children: (<FicheRappel {...this.props}/>)
            })
        }

        if (selected.commentaires.length > 0) {
            tabs.push({
                key: "4",
                label: (<Fragment><CommentOutlined/> {selected.commentaires.length} Activité(s)</Fragment>),
                children: (<FicheCom {...this.props}/>)
            })
        }

        if (selected.categories.length > 2) {
            tabs.push({
                key: "0",
                label: (<Fragment><TagsOutlined/> {selected.categories.length} Categorie(s)</Fragment>),
                children: (<FicheCategories {...this.props}/>)
            })
        }

        if (selected.adresses.length > 0) {
            tabs.push({
                key: "3",
                label: (
                    <Fragment><EnvironmentOutlined/> {selected.adresses.length} Adresse(s) Supplémentaire</Fragment>),
                children: (<FicheAdresses {...this.props}/>)
            })
        }

        if (selected.enfants.length > 0) {
            tabs.push({
                key: "1",
                label: (<Fragment><SkinOutlined/> {selected.enfants.length} Enfant(s)</Fragment>),
                children: (<FicheEnfants {...this.props}/>)
            })
        }

        if (selected.familyLinks.length > 0) {
            tabs.push({
                key: "2",
                label: (<Fragment><NodeIndexOutlined/> {selected.familyLinks.length} Lien(s) Familiaux</Fragment>),
                children: (<FicheFamilleLink {...this.props}/>)
            })
        }


        if (selected.links.length > 0) {
            tabs.push({
                key: "5",
                label: (<Fragment><LinkOutlined/> {selected.links.length} Lien(s)</Fragment>),
                children: (<FicheLinks {...this.props}/>)
            })
        }

        if (selected.docs.length > 0) {
            tabs.push({
                key: "6",
                label: (<Fragment><FileOutlined/> {selected.docs.length} Document(s)</Fragment>),
                children: (<FicheDocs {...this.props}/>)
            })
        }

        if (tabs.length === 0) {
            return null
        }

        return (
            <Fragment>
                <Divider/>
                <Tabs
                    onChange={(key) => this.onChange(key)}
                    tabPosition={"left"}
                    style={{margin: "20px 0", minHeight: isMobile ? 0 : "70vh"}}
                    items={!isMobile ? tabs : tabs.map((i) => {
                        return {...i, children: null}
                    })}
                />

                {isMobile && (
                    <Fragment>
                        <Divider/>
                        <Col style={{minHeight: "40vh"}}>
                            {tabs.find(i => i.key === this.state.key)?.children || tabs[0]?.children}
                        </Col>
                    </Fragment>
                )}
            </Fragment>
        )
    }
}
